(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    

  (function () {
    'use strict';

    /* ── Helpers ────────────────────────────────────────────────── */

    function cartRequest(body) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function formatMoney(cents) {
      // Formats cents to shop money string (e.g. CHF 12.90)
      // Uses Shopify's money_format from meta tag if present, else simple fallback
      var meta = document.querySelector('meta[name="money-format"]');
      if (meta) {
        var fmt = decodeURIComponent(meta.getAttribute('content'));
        return fmt.replace('{{amount}}', (cents / 100).toFixed(2))
                  .replace('{{amount_no_decimals}}', Math.round(cents / 100));
      }
      return 'CHF\u00a0' + (cents / 100).toFixed(2);
    }

    function setItemLoading(itemEl, state) {
      itemEl.classList.toggle('is-loading', state);
    }

    /* ── Update header cart count ───────────────────────────────── */

    function updateHeaderCount(count) {
      var badge = document.querySelector('.fwb-header__cart-count');
      var cartLink = document.querySelector('.fwb-header__cart');
      if (!cartLink) return;

      if (count > 0) {
        if (badge) {
          badge.textContent = count;
        } else {
          badge = document.createElement('span');
          badge.className = 'fwb-header__cart-count';
          badge.textContent = count;
          cartLink.appendChild(badge);
        }
      } else {
        if (badge) badge.remove();
      }

      cartLink.setAttribute('aria-label', 'Warenkorb (' + count + ')');
    }

    /* ── Update subtotal display ────────────────────────────────── */

    function updateSubtotal(cart) {
      var el = document.getElementById('fwb-subtotal');
      if (el) el.textContent = formatMoney(cart.total_price);
    }

    /* ── Remove an item from the DOM ────────────────────────────── */

    function removeItemFromDOM(key) {
      var itemEl = document.querySelector('.fwb-cart__item[data-item-key="' + key + '"]');
      if (!itemEl) return;
      itemEl.style.transition = 'opacity 0.25s ease, max-height 0.35s ease';
      itemEl.style.overflow = 'hidden';
      itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
      requestAnimationFrame(function () {
        itemEl.style.opacity = '0';
        itemEl.style.maxHeight = '0';
        itemEl.style.paddingBlock = '0';
        itemEl.style.marginBlock = '0';
      });
      setTimeout(function () { itemEl.remove(); }, 380);
    }

    /* ── Show empty state if no items left ──────────────────────── */

    function checkEmpty(cart) {
      if (cart.item_count === 0) {
        // Reload so the empty state section renders from Liquid
        window.location.reload();
      }
    }

    /* ── Quantity change handler ─────────────────────────────────── */

    function changeQuantity(key, newQty) {
      var itemEl = document.querySelector('.fwb-cart__item[data-item-key="' + key + '"]');
      if (itemEl) setItemLoading(itemEl, true);

      cartRequest({ id: key, quantity: newQty })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          updateSubtotal(cart);

          if (newQty === 0) {
            removeItemFromDOM(key);
            checkEmpty(cart);
          } else {
            // Find updated line and refresh price
            var updatedItem = cart.items.find(function (i) { return i.key === key; });
            if (updatedItem && itemEl) {
              var priceEl = itemEl.querySelector('.fwb-cart__line-total');
              if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
              var input = itemEl.querySelector('.fwb-cart__stepper-input');
              if (input) input.value = updatedItem.quantity;
              setItemLoading(itemEl, false);
            }
          }
        })
        .catch(function () {
          if (itemEl) setItemLoading(itemEl, false);
        });
    }

    /* ── Bind events ─────────────────────────────────────────────── */

    var itemsContainer = document.getElementById('fwb-cart-items');
    if (!itemsContainer) return;

    // Stepper +/− buttons
    itemsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.fwb-cart__stepper-btn');
      if (!btn) return;

      var key = btn.dataset.itemKey;
      var action = btn.dataset.action;
      var input = itemsContainer.querySelector('.fwb-cart__stepper-input[data-item-key="' + key + '"]');
      if (!input) return;

      var current = parseInt(input.value, 10) || 0;
      var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);

      input.value = newQty;
      changeQuantity(key, newQty);
    });

    // Direct input change (on blur)
    itemsContainer.addEventListener('change', function (e) {
      var input = e.target.closest('.fwb-cart__stepper-input');
      if (!input) return;

      var key = input.dataset.itemKey;
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newQty;
      changeQuantity(key, newQty);
    });

    // Remove button
    itemsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.fwb-cart__remove');
      if (!btn) return;

      var key = btn.dataset.itemKey;
      var itemEl = document.querySelector('.fwb-cart__item[data-item-key="' + key + '"]');
      if (itemEl) setItemLoading(itemEl, true);
      changeQuantity(key, 0);
    });

    // Checkout button loading state
    var checkoutBtn = document.getElementById('fwb-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.closest('form').addEventListener('submit', function () {
        checkoutBtn.classList.add('is-loading');
        checkoutBtn.textContent = '…';
      });
    }

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.getElementById('fwb-header');
  const burger = document.getElementById('fwb-burger');
  const mobileNav = document.getElementById('fwb-mobile-nav');

  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }, { passive: true });

  burger.addEventListener('click', () => {
    const open = burger.getAttribute('aria-expanded') === 'true';
    burger.setAttribute('aria-expanded', String(!open));
    mobileNav.classList.toggle('is-open', !open);
    mobileNav.setAttribute('aria-hidden', String(open));
  });

  // Dropdowns
  document.querySelectorAll('.fwb-header__dropdown-trigger').forEach(trigger => {
    const menu = trigger.nextElementSibling;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      // Close all others
      document.querySelectorAll('.fwb-header__dropdown-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        t.nextElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        menu.classList.add('is-open');
      }
    });
  });

  // Close on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.fwb-header__dropdown-trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      t.nextElementSibling.classList.remove('is-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-authors"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fwb-authors__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.fwb-authors__bio-wrap');
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const track = document.getElementById('fwb-testimonials-track');
    if (!track) return;

    const slides = track.querySelectorAll('.fwb-testimonials__slide');
    const dotsWrap = document.getElementById('fwb-testi-dots');
    const prevBtn = document.getElementById('fwb-testi-prev');
    const nextBtn = document.getElementById('fwb-testi-next');
    let current = 0;

    // Build dots
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'fwb-testimonials__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Seite ' + (i + 1));
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    });

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dotsWrap.querySelectorAll('.fwb-testimonials__dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    }

    prevBtn.addEventListener('click', () => goTo(current - 1));
    nextBtn.addEventListener('click', () => goTo(current + 1));

    // Auto-advance
    let timer = setInterval(() => goTo(current + 1), 6000);
    track.addEventListener('mouseenter', () => clearInterval(timer));
    track.addEventListener('mouseleave', () => { timer = setInterval(() => goTo(current + 1), 6000); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ueber-uns"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fwb-ueber-uns__author-row-header').forEach(header => {
    header.addEventListener('click', () => {
      const card = header.closest('.fwb-ueber-uns__author-card');
      const detail = card.querySelector('.fwb-ueber-uns__author-detail');
      const toggle = card.querySelector('.fwb-ueber-uns__toggle');
      const isOpen = detail.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // Open all authors by default
  document.querySelectorAll('.fwb-ueber-uns__author-detail').forEach((detail, i) => {
    detail.classList.add('is-open');
    detail.closest('.fwb-ueber-uns__author-card')
      .querySelector('.fwb-ueber-uns__toggle')
      .setAttribute('aria-expanded', 'true');
  });

  } catch(e) { console.error(e); }
})();
})();
